import { CountryList } from './services/countriesList.model';
import { HubUserSettings, UserData } from './services/models/userData.model';

export interface HubState {
  userData: UserData;
  userSettings: HubUserSettings;
  loading: boolean;
  error: string | null;
  currentRoute: string;
  countryList: CountryList[];
}

export const initialState: HubState = {
  userData: {} as UserData,
  userSettings: {
    id: 0,
    userId: '',
    darkMode: false,
    searchField: 'SecretWord'
  },
  countryList: [],
  loading: true,
  error: null,
  currentRoute: ''
};
